export const portfolioData = {
  hero: {
    label: "Portfolio 2025",
    name: "田中 美咲",
    field: "Visual Design & UX",
    tagline: "Creating Meaningful Digital Experiences",
    description: "デジタルとアナログの境界を超えて、人々の心に響くデザインを追求しています。ユーザー体験を第一に考え、美しさと機能性を両立させたデザインソリューションを提供します。"
  },
  about: {
    title: "私について",
    paragraphs: [
      "東京藝術大学デザイン科で視覚デザインとユーザーエクスペリエンスを専攻しています。デザインは単なる装飾ではなく、人々の生活を豊かにし、問題を解決するための強力なツールだと信じています。",
      "幼少期から絵を描くことが好きで、中学生の頃からグラフィックデザインに興味を持ち始めました。高校時代にはWebデザインやUI/UXデザインの世界に魅了され、独学でAdobe Creative SuiteやFigmaなどのツールを習得しました。",
      "大学では理論と実践の両面からデザインを学び、心理学、色彩理論、タイポグラフィ、情報設計など、幅広い知識を身につけてきました。特にユーザー中心設計の重要性を深く理解し、リサーチからプロトタイピング、ユーザーテストまで、デザインプロセス全体を経験しています。",
      "現在は、スタートアップ企業でのインターンシップを通じて実務経験を積んでおり、クライアントとのコミュニケーション、プロジェクト管理、チームでの協働作業のスキルも磨いています。デザインを通じて社会に貢献し、人々の生活をより良くすることが私の目標です。"
    ],
    quote: "デザインは問題解決のための言語であり、美しさはその解決策が正しいことを示す証です。私は常にユーザーの視点に立ち、彼らのニーズを深く理解することから始めます。",
    profile: {
      name: "田中 美咲",
      title: "Visual Designer & UX Specialist",
      social: [
        { icon: "ri-instagram-line", url: "#" },
        { icon: "ri-twitter-x-line", url: "#" },
        { icon: "ri-linkedin-line", url: "#" },
        { icon: "ri-behance-line", url: "#" }
      ]
    }
  },
  skills: [
    {
      title: "UI/UX Design",
      description: "ユーザー中心設計の原則に基づき、直感的で使いやすいインターフェースを設計します。ワイヤーフレーム、プロトタイプ、ユーザーテストを通じて最適な体験を追求します。",
      level: 5,
      image: "https://readdy.ai/api/search-image?query=modern%20minimalist%20user%20interface%20design%20workspace%20with%20clean%20wireframes%20and%20prototypes%20on%20digital%20screens%2C%20neutral%20beige%20and%20dark%20tones%2C%20professional%20design%20studio%20atmosphere%20with%20soft%20lighting%2C%20high%20quality%20photography%2C%20shallow%20depth%20of%20field%2C%20contemporary%20aesthetic&width=800&height=1000&seq=skill1&orientation=portrait"
    },
    {
      title: "Visual Design",
      description: "色彩理論、タイポグラフィ、レイアウトの原則を駆使して、視覚的に魅力的で効果的なデザインを制作します。ブランドアイデンティティの構築も得意としています。",
      level: 5,
      image: "https://readdy.ai/api/search-image?query=sophisticated%20visual%20design%20composition%20with%20typography%20specimens%20and%20color%20palettes%2C%20warm%20beige%20and%20deep%20charcoal%20tones%2C%20elegant%20design%20materials%20arranged%20artistically%2C%20professional%20photography%2C%20soft%20natural%20lighting%2C%20refined%20aesthetic&width=800&height=1000&seq=skill2&orientation=portrait"
    },
    {
      title: "Web Design",
      description: "レスポンシブデザインの原則に従い、あらゆるデバイスで美しく機能するWebサイトを設計します。HTML、CSS、JavaScriptの基礎知識も持っています。",
      level: 4,
      image: "https://readdy.ai/api/search-image?query=modern%20web%20design%20development%20setup%20with%20multiple%20responsive%20device%20mockups%2C%20clean%20minimalist%20workspace%2C%20neutral%20color%20palette%20with%20warm%20accents%2C%20professional%20studio%20lighting%2C%20contemporary%20digital%20design%20aesthetic&width=800&height=1000&seq=skill3&orientation=portrait"
    },
    {
      title: "Branding",
      description: "企業やプロダクトの本質を理解し、それを視覚的に表現するブランドアイデンティティを構築します。ロゴ、カラーパレット、タイポグラフィの選定を行います。",
      level: 4,
      image: "https://readdy.ai/api/search-image?query=elegant%20branding%20identity%20materials%20with%20logo%20designs%20and%20brand%20guidelines%2C%20sophisticated%20neutral%20tones%20with%20deep%20charcoal%20accents%2C%20professional%20design%20studio%20setup%2C%20high%20quality%20photography%2C%20refined%20aesthetic&width=800&height=1000&seq=skill4&orientation=portrait"
    },
    {
      title: "Illustration",
      description: "デジタルとアナログの両方で、コンセプトを視覚化するイラストレーションを制作します。キャラクターデザインからアイコン制作まで幅広く対応します。",
      level: 4,
      image: "https://readdy.ai/api/search-image?query=artistic%20illustration%20workspace%20with%20digital%20drawing%20tablet%20and%20sketches%2C%20warm%20neutral%20color%20palette%2C%20creative%20studio%20environment%20with%20natural%20lighting%2C%20professional%20photography%2C%20contemporary%20artistic%20aesthetic&width=800&height=1000&seq=skill5&orientation=portrait"
    },
    {
      title: "Motion Design",
      description: "After EffectsやPrincipleを使用して、UIアニメーションやモーショングラフィックスを制作します。動きを通じてストーリーを伝えます。",
      level: 3,
      image: "https://readdy.ai/api/search-image?query=modern%20motion%20design%20studio%20with%20animation%20timeline%20and%20dynamic%20graphics%20on%20screen%2C%20sleek%20dark%20interface%20with%20warm%20accent%20lighting%2C%20professional%20digital%20workspace%2C%20high%20quality%20photography%2C%20contemporary%20aesthetic&width=800&height=1000&seq=skill6&orientation=portrait"
    }
  ],
  projects: [
    {
      id: 1,
      title: "EcoLife App",
      category: "UI/UX Design",
      year: "2024",
      featured: true,
      image: "https://readdy.ai/api/search-image?query=modern%20eco-friendly%20mobile%20app%20interface%20design%20mockup%20on%20smartphone%2C%20clean%20minimalist%20UI%20with%20nature-inspired%20elements%2C%20neutral%20beige%20background%2C%20professional%20product%20photography%2C%20soft%20natural%20lighting&width=600&height=750&seq=proj1&orientation=portrait"
    },
    {
      id: 2,
      title: "Urban Coffee Branding",
      category: "Branding",
      year: "2024",
      featured: false,
      image: "https://readdy.ai/api/search-image?query=sophisticated%20coffee%20shop%20branding%20materials%20with%20logo%20and%20packaging%20design%2C%20warm%20neutral%20tones%20with%20deep%20brown%20accents%2C%20elegant%20product%20photography%2C%20professional%20studio%20lighting%2C%20refined%20aesthetic&width=600&height=750&seq=proj2&orientation=portrait"
    },
    {
      id: 3,
      title: "Museum Website Redesign",
      category: "Web Design",
      year: "2023",
      featured: false,
      image: "https://readdy.ai/api/search-image?query=elegant%20museum%20website%20design%20on%20desktop%20screen%2C%20minimalist%20interface%20with%20art%20gallery%20aesthetics%2C%20neutral%20color%20palette%2C%20professional%20photography%2C%20contemporary%20digital%20design&width=600&height=750&seq=proj3&orientation=portrait"
    },
    {
      id: 4,
      title: "Mindful Meditation App",
      category: "UI/UX Design",
      year: "2023",
      featured: false,
      image: "https://readdy.ai/api/search-image?query=serene%20meditation%20app%20interface%20on%20mobile%20device%2C%20calming%20minimalist%20design%20with%20soft%20gradients%2C%20warm%20neutral%20tones%2C%20professional%20product%20photography%2C%20peaceful%20atmosphere&width=600&height=750&seq=proj4&orientation=portrait"
    },
    {
      id: 5,
      title: "Fashion Editorial Layout",
      category: "Visual Design",
      year: "2024",
      featured: false,
      image: "https://readdy.ai/api/search-image?query=sophisticated%20fashion%20magazine%20editorial%20layout%20design%2C%20elegant%20typography%20and%20photography%2C%20neutral%20beige%20and%20charcoal%20tones%2C%20professional%20print%20design%2C%20refined%20aesthetic&width=600&height=750&seq=proj5&orientation=portrait"
    },
    {
      id: 6,
      title: "Smart Home Dashboard",
      category: "UI/UX Design",
      year: "2023",
      featured: false,
      image: "https://readdy.ai/api/search-image?query=modern%20smart%20home%20control%20dashboard%20interface%20on%20tablet%2C%20sleek%20minimalist%20UI%20with%20dark%20mode%2C%20professional%20product%20photography%2C%20contemporary%20digital%20design%20aesthetic&width=600&height=750&seq=proj6&orientation=portrait"
    },
    {
      id: 7,
      title: "Organic Skincare Packaging",
      category: "Branding",
      year: "2024",
      featured: false,
      image: "https://readdy.ai/api/search-image?query=elegant%20organic%20skincare%20product%20packaging%20design%2C%20minimalist%20bottles%20and%20boxes%2C%20warm%20neutral%20tones%20with%20natural%20elements%2C%20professional%20product%20photography%2C%20refined%20aesthetic&width=600&height=750&seq=proj7&orientation=portrait"
    },
    {
      id: 8,
      title: "Travel Blog Platform",
      category: "Web Design",
      year: "2023",
      featured: false,
      image: "https://readdy.ai/api/search-image?query=modern%20travel%20blog%20website%20interface%20design%20on%20laptop%2C%20clean%20layout%20with%20beautiful%20photography%2C%20neutral%20color%20palette%2C%20professional%20digital%20design%2C%20contemporary%20aesthetic&width=600&height=750&seq=proj8&orientation=portrait"
    }
  ],
  featuredProject: {
    title: "EcoLife App - 持続可能なライフスタイルを支援するモバイルアプリケーション",
    description: "環境に配慮した生活習慣を楽しく継続できるよう設計された、包括的なエコライフ支援アプリです。カーボンフットプリントの追跡、エコチャレンジ、コミュニティ機能を統合し、ユーザーが自然と環境意識を高められる体験を提供します。",
    details: [
      "ユーザーリサーチから始まり、20名以上のターゲットユーザーにインタビューを実施。環境問題への関心は高いものの、具体的な行動に移せない理由を深掘りしました。",
      "情報設計では、複雑な環境データを視覚的に分かりやすく表現することに注力。カラーコーディング、アイコン、グラフを効果的に組み合わせ、一目で状況を把握できるダッシュボードを設計しました。",
      "プロトタイプを用いたユーザーテストを3回実施し、フィードバックを基に改善を重ねました。特にオンボーディングフローとナビゲーション構造を大幅に見直し、初回利用時の離脱率を40%削減することに成功しました。"
    ],
    image: "https://readdy.ai/api/search-image?query=comprehensive%20mobile%20app%20design%20showcase%20with%20multiple%20screens%20displaying%20eco-friendly%20lifestyle%20tracking%20interface%2C%20modern%20minimalist%20UI%20with%20nature-inspired%20color%20palette%2C%20professional%20product%20photography%20on%20neutral%20beige%20background%2C%20high%20quality%20detailed%20mockup&width=1400&height=800&seq=featured1&orientation=landscape"
  },
  testimonials: [
    {
      text: "美咲さんのデザインは、美しさと機能性が完璧に調和しています。彼女はユーザーのニーズを深く理解し、それを視覚的に表現する能力に長けています。プロジェクトを通じて、常にプロフェッショナルな姿勢を保ち、期待以上の成果を出してくれました。",
      author: "山田 太郎",
      title: "プロダクトマネージャー",
      company: "TechStart Inc.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=professional%20japanese%20business%20person%20portrait%2C%20confident%20expression%2C%20modern%20office%20background%2C%20natural%20lighting%2C%20high%20quality%20professional%20photography%2C%20neutral%20tones&width=600&height=800&seq=testimonial1&orientation=portrait"
    }
  ]
};

export const contactInfo = {
  email: "misaki.tanaka@example.com",
  phone: "+81 90-1234-5678",
  location: "東京都渋谷区"
};